import { createContext } from "preact";

export default createContext({ token: undefined });
